import { render, staticRenderFns } from "./InsuredBlackList.vue?vue&type=template&id=325850cb&"
import script from "./InsuredBlackList.vue?vue&type=script&lang=js&"
export * from "./InsuredBlackList.vue?vue&type=script&lang=js&"
import style0 from "./InsuredBlackList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InsuredBlackList.vue"
export default component.exports